<template lang="html">
    <div class="page" id="diary">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Diary Settings</h2>

                <ul class="links">
                    <li>
                        <button
                            class="openSettings"
                            @click.prevent="contextOpen = !contextOpen"
                            type="button"
                            name="button"
                        >
                            <img
                                v-if="!contextOpen"
                                src="@/assets/settings-dark-green-outline.svg"
                            />
                            <img v-else src="@/assets/cog.svg" />
                        </button>
                    </li>
                    <li>
                        <router-link class="cancel" :to="{ name: 'proLesson' }"
                            ><x-icon class="icon"
                        /></router-link>
                    </li>
                </ul>

                <ul class="contextMenu" v-if="contextOpen">
                    <li>
                        <router-link :to="{ name: 'proLessonAvailability' }"
                            >Weekly availability</router-link
                        >
                    </li>
                    <li>
                        <router-link :to="{ name: 'proDiaryAvailability' }"
                            >Future availability</router-link
                        >
                    </li>
                    <li>
                        <router-link :to="{ name: 'proLessonSettings' }"
                            >Duration and pricing</router-link
                        >
                    </li>
                    <li>
                        <router-link
                            :to="{ name: 'proVideoLessonSettings' }"
                            v-if="$env.VUE_APP_VIDEO_LESSON_ENABLED"
                            >Video lesson settings</router-link
                        >
                    </li>
                </ul>
            </header>

            <span class="info"> Tap twice to edit availability </span>

            <date-picker
                :select-attribute="selectAttribute"
                style="width: 100%"
                :attributes="availableDates"
                @update:to-page="changeMonth"
                :min-date="new Date()"
                @dayclick="clickdate"
                @input="selectDate"
                :is-range="true"
                class="datePicker"
                :value="new Date()"
            />

            <button v-if="deleteOpen" @click.prevent="deleteAvailability" class="button red">
                Delete availability
            </button>

            <empty-placeholder class="mt30 mb0">
                TIP: To select more than one day tap the start date and then the finish date.
            </empty-placeholder>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
export default {
    name: "manage-diary",
    components: { EmptyPlaceholder, FadeImage, XIcon, "date-picker": DatePicker },
    data() {
        return {
            deleteOpen: false,
            contextOpen: false,
            selectedDate: false,
            monthYear: false,
            dates: [],
            bookings: [],
            selectAttribute: {
                highlight: {
                    contentClass: "selected",
                },
            },
        };
    },
    computed: {
        availableDates() {
            return [
                {
                    highlight: {
                        contentClass: "available",
                    },
                    dates: this.dates.map(($date) => {
                        if (
                            this.$date($date.date).isAfter(this.$date()) &&
                            !this.$date($date.date)
                                .startOf("day")
                                .isSame(this.$date().startOf("day"))
                        ) {
                            return this.$date($date.date).format("YYYY-MM-DD");
                        }
                    }),
                },
                {
                    highlight: {
                        contentClass: "booked",
                    },
                    dates: this.bookings.map(($date) => {
                        if (
                            this.$date($date.date).isAfter(this.$date()) &&
                            !this.$date($date.date)
                                .startOf("day")
                                .isSame(this.$date().startOf("day"))
                        ) {
                            return this.$date($date.date).format("YYYY-MM-DD");
                        }
                    }),
                },
            ];
        },
    },
    methods: {
        clickdate(date) {
            console.log(date);

            if (date.isDisabled) {
                return false;
            }

            this.deleteOpen = true;

            var start = this.$date(date.date).format("YYYY-MM-DD");
            var end = this.$date(date.date).format("YYYY-MM-DD");

            this.selectedDate = {
                start: start,
                end: end,
            };
        },
        selectDate(date) {
            this.$nextTick(() => {
                this.selectedDate = date;
                var start = this.$date(date.start).format("YYYY-MM-DD");
                var end = this.$date(date.end).format("YYYY-MM-DD");
                if (start !== end) {
                    this.deleteOpen = true;
                } else {
                    this.$router.push({
                        name: "proLessonDiarySetting",
                        params: { start: start, end: end },
                    });
                }
            });

            this.deleteOpen = false;
        },
        deleteAvailability() {
            console.log(this.selectedDate);
            var start = this.$date(this.selectedDate.start).format("YYYY-MM-DD");
            var end = this.$date(this.selectedDate.end).format("YYYY-MM-DD");
            console.log(start);
            console.log(end);
            //var month = this.$date

            this.$confirm(
                "Changes to your availability will have an impact on future bookings. Affected bookings will be automatically cancelled and Players notified of any changes made.",
                () => {
                    window.axios
                        .post("/availability-date-range", { start: start, end: end })
                        .then(() => {
                            this.getAvailability();
                            this.$notify("Lessons and availability deleted");
                        });
                },
                "Yes, continue",
                "No, cancel",
            );
        },
        getAvailability() {
            var $start = this.$date(this.monthYear["year"] + "-" + this.monthYear["month"] + "-05")
                .startOf("month")
                .format("YYYY-MM-DD");
            var $end = this.$date(this.monthYear["year"] + "-" + this.monthYear["month"] + "-05")
                .endOf("month")
                .format("YYYY-MM-DD");

            window.axios.get("/availability?start=" + $start + "&end=" + $end).then((response) => {
                this.dates = response.data.availability;
                this.bookings = response.data.bookings;
            });
        },
        changeMonth($monthYear) {
            this.monthYear = $monthYear;
            this.dates = [];
            this.$nextTick(() => {
                this.getAvailability($monthYear);
            });
        },
    },
};
</script>

<style lang="scss">
.openSettings {
    transform: translateY(-3px);
}
#diary {
    .contextMenu {
        position: absolute;
        right: 40px;
        z-index: 9;
    }
}
</style>
